// extracted by mini-css-extract-plugin
export default {"container":"Question_container__lZ0dW","heading":"Question_heading__zx9yf","answer":"Question_answer__8DnMO","textbox":"Question_textbox__VThGv"};